// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"6822aa24","264":"603a3d20","300":"5b44910f","382":"a7e2b503","432":"06fec88d","453":"a0e99bc7","520":"d7866a0f","599":"2904ebd4","775":"ae46cdae"}[chunkId] + ".chunk.js";
};